import { defineStore } from 'pinia';

export enum ProductGroupEditType {
    ProductGroup
}

export interface ProductGroupEditStoreState {
    edit?: {
        key?: number;
        type?: ProductGroupEditType;
    };
}

export const useProductGroupEditStore = defineStore('configuration-product-group-edit-store', {
    state: (): ProductGroupEditStoreState => ({
        edit: null
    }),
    getters: {
        isEdit(): (type: ProductGroupEditType, id: number) => boolean {
            return (type: ProductGroupEditType, id: number) => this.edit?.type === type && this.edit?.key === id;
        },
        editing(): boolean {
            return this.edit !== null && this.edit?.type !== null && this.edit?.key !== null;
        }
    },
    actions: {
        init() {
            this.edit = null;
        },
        openEdit(type: ProductGroupEditType, key: number) {
            this.edit = { type, key };
        },
        closeEdit() {
            this.edit = null;
        }
    }
});
